import { adminApiClient } from './api'

export const adminLlmService = {
  async overview(params?: { start?: string; end?: string }) {
    const { data } = await adminApiClient.get('/admin/llm/overview', { params })
    return data as {
      total_requests: number
      input_tokens: number
      output_tokens: number
      total_tokens: number
      avg_latency_ms: number
      cost_usd: number
    }
  },
  async byUser(params?: { start?: string; end?: string; limit?: number }) {
    const { data } = await adminApiClient.get('/admin/llm/by-user', { params })
    return data as Array<{ user_id: string; user_email: string; requests: number; total_tokens: number; cost_usd: number }>
  },
  async byBot(params?: { start?: string; end?: string; limit?: number }) {
    const { data } = await adminApiClient.get('/admin/llm/by-bot', { params })
    return data as Array<{ bot_id: string; bot_name: string; owner_email: string; requests: number; total_tokens: number; cost_usd: number }>
  },
  async byModel(params?: { start?: string; end?: string; limit?: number }) {
    const { data } = await adminApiClient.get('/admin/llm/by-model', { params })
    return data as Array<{ model: string; provider: string; requests: number; total_tokens: number; cost_usd: number }>
  },
  async trainingUsage(params?: { start?: string; end?: string; limit?: number }) {
    const { data } = await adminApiClient.get('/admin/llm/training-usage', { params })
    return data as Array<{
      user_id: string
      user_email: string
      bot_name: string
      extractions: number
      input_tokens: number
      output_tokens: number
      total_tokens: number
      cost_usd: number
    }>
  },
}
